import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../../shared/constants';

@Component({
	selector: 'app-profile-create',
	templateUrl: './profile-create.component.html',
	styleUrl: './profile-create.component.css'
})
export class ProfileCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/profile-list",
			name: "Profile"
		}
	];
	uId: any = null;
	pagetitle = "Create Profile";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	scaleList: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				description: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				scale: [null]
			});
			this.getScaleList();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-profile/" + this.uId, name: "Edit" });
				this.pagetitle = "Edit Profile";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-profile", name: "Create" });
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	getScaleList() {
		this.apiService.getAllScaleList().subscribe({
			next: (data: any) => {
				this.scaleList = data.data.map((s) => {
					s["id"] = parseInt(s["id"]);
					return s;
				});
			}, error: (error) => {
				this.scaleList = [];
				this.toastr.error("Unable to fetch parent scale list.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getProfileDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.details = data;
				this.f.name.setValue(this.details.name);
				this.f.description.setValue(this.details.description);
				this.f.scale.setValue(this.details.scale);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			name: this.f.name.value,
			description: this.f.description.value,
			scale: this.f.scale.value
		};
		let action = "create";
		if (this.uId) {
			payload["id"] = this.uId;
			action = "edit";
		}
		this.showLoader = true;
		this.apiService.createUpdateProfile(payload, action).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				if (data["status"] == 409) {
					this.restoreProfile(data["encryptid"]);
				} else if (data["status"] == 400) {
					this.alreadyExistsError();
				} else {
					this.toastr.success("Saved successfully.", 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.gotoList();
				}
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				if (error.status == 409) {
					this.restoreProfile(error.error.encryptid);
				} else {
					let errorMsg: any = "Something went wrong.";
					if (error.status == 400) {
						this.alreadyExistsError();
					} else {
						errorMsg = error.error;
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	alreadyExistsError() {
		let key = "name";
		let val: any = "Already exists";
		this.moduleForm.controls[key].setErrors({ incorrect: true });
		this.customError[key] = val;
		let selector = "#" + key;
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 60 + 'px'
			}, 'fast');
		} catch (error) { }
		$(selector).focus();
	}

	restoreProfile(id: any) {
		Swal.fire({
			title: 'Already Exists',
			html: 'Profile already exists. Do you want to restore it?',
			icon: 'question',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, Restore!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#3e4fb1'
		}).then((result) => {
			if (result.value) {
				this.apiService.restoreProfile(id).subscribe({
					next: (data: any) => {
						this.toastr.success("Profile restored successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.gotoList();
					}, error: (error) => {
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}

	gotoList() {
		this.router.navigate(['/app/profile-list']);
	}
}
